import React from 'react';
import '../styles/theAccess1.scss';
import CategoryIndicator from '../components/CategoryIndicator';
import fittingM from '../assets/access1/fittingM.png';
import fittingD from '../assets/access1/fittingD.png';
import suitM from '../assets/access1/suitM.png';
import suitD from '../assets/access1/suitD.png';
import gloveD from '../assets/access1/gloveD.png';
import gloveM from '../assets/access1/gloveM.png';
import helmetD from '../assets/access1/helmetD.png';
import helmetM from '../assets/access1/helmetM.png';
import jointD from '../assets/access1/jointD.png';
import jointM from '../assets/access1/jointM.png';
import controlD from '../assets/access1/controlD.png';
import controlM from '../assets/access1/controlM.png';
import backD from '../assets/access1/backD.png';
import backM from '../assets/access1/backM.png';

const theAccess1 = ({ screenWidth }) => {
  return (
    <div className="theAccess1" id="access1">
      <div className="theAccess1__textCont theAccess1__textCont-mobile">
        <CategoryIndicator origin="introducing" />
        <h4 className="bold">The Access I</h4>
        <p className="small">
          Introducing the Access I, a conceptual model spacesuit inspired by Morgan Stanley’s vision
          of a more inclusive future.
        </p>
        <p className="small">
          Morgan Stanley has partnered with experts, historians, and designers to imagine a suit
          that provides expanded access to space for more women and breaks down barriers for a new
          generation of explorers.
        </p>
      </div>
      <div className="theAccess1__contents">
        <div className=" theAccess1__contents-1">
          <div className="theAccess1__contents-1__row1">
            <div className="theAccess1__textCont theAccess1__textCont-desktop">
              <CategoryIndicator origin="introducing" />
              <h4 className="bold">The Access I</h4>
              <p className="small">
                Introducing the Access I, a conceptual model spacesuit inspired by Morgan Stanley’s
                vision of a more inclusive future.
              </p>
              <p className="small">
                Morgan Stanley has partnered with experts, historians, and designers to imagine a
                suit that provides expanded access to space for more women and breaks down barriers
                for a new generation of explorers.
              </p>
            </div>
            <img className="theAccess1__photos-50" src={screenWidth > 720 ? suitD : suitM} alt="" />
          </div>
          <div className="theAccess1__contents-1__row2">
            <img
              className="theAccess1__photos-50"
              src={screenWidth > 720 ? gloveD : gloveM}
              alt=""
            />
            <img
              className="theAccess1__photos-50"
              src={screenWidth > 720 ? helmetD : helmetM}
              alt=""
            />
          </div>
          <img
            className="theAccess1__photos-100 theAccess1__photos-100-desktop"
            src={fittingD}
            alt=""
          />
        </div>

        <div className="theAccess1__contents theAccess1__contents-2">
          <img
            className="theAccess1__photos-100"
            src={screenWidth > 720 ? controlD : controlM}
            alt=""
          />
          <img
            className="theAccess1__photos-100"
            src={screenWidth > 720 ? jointD : jointM}
            alt=""
          />
          <img className="theAccess1__photos-100" src={screenWidth > 720 ? backD : backM} alt="" />
        </div>
      </div>
      <img className="theAccess1__photos-100 theAccess1__photos-100-mobile" src={fittingM} alt="" />
    </div>
  );
};

export default theAccess1;
